export const financeKpis = {
  cashOnHand: 185000000,
  monthlyRevenue: 32500000,
  monthlyExpenses: 28750000,
  accountsReceivable: 45000000,
  accountsPayable: 37200000,
  workingCapital: 7800000,
  netIncomeMargin: 0.18,
  debtToEquity: 0.72,
  overdueReceivables: 5400000,
  overduePayables: 3200000
};

export const fiscalPeriods = [
  { id: 'PER-2024-01', year: 2024, month: 1, label: 'Enero 2024', isClosed: true },
  { id: 'PER-2024-02', year: 2024, month: 2, label: 'Febrero 2024', isClosed: true },
  { id: 'PER-2024-03', year: 2024, month: 3, label: 'Marzo 2024', isClosed: false },
  { id: 'PER-2024-04', year: 2024, month: 4, label: 'Abril 2024', isClosed: false }
];

export const chartOfAccounts = [
  {
    id: 'ACC-1000',
    code: '1',
    name: 'Activos',
    type: 'ASSET',
    level: 1,
    children: [
      {
        id: 'ACC-1100',
        code: '1.1',
        name: 'Activo Circulante',
        type: 'ASSET',
        level: 2,
        children: [
          {
            id: 'ACC-1110',
            code: '1.1.1',
            name: 'Caja y Bancos',
            type: 'ASSET',
            level: 3,
            balance: 135000000
          },
          {
            id: 'ACC-1120',
            code: '1.1.2',
            name: 'Cuentas por Cobrar',
            type: 'ASSET',
            level: 3,
            balance: 45000000
          },
          {
            id: 'ACC-1140',
            code: '1.1.4',
            name: 'Proyectos CIP',
            type: 'ASSET',
            level: 3,
            balance: 28500000
          }
        ]
      },
      {
        id: 'ACC-1200',
        code: '1.2',
        name: 'Activo Fijo',
        type: 'ASSET',
        level: 2,
        children: [
          {
            id: 'ACC-1210',
            code: '1.2.1',
            name: 'Plantas Solares',
            type: 'ASSET',
            level: 3,
            balance: 480000000
          },
          {
            id: 'ACC-1220',
            code: '1.2.2',
            name: 'Equipos Eólicos',
            type: 'ASSET',
            level: 3,
            balance: 215000000
          }
        ]
      }
    ]
  },
  {
    id: 'ACC-2000',
    code: '2',
    name: 'Pasivos',
    type: 'LIABILITY',
    level: 1,
    balance: 410000000
  },
  {
    id: 'ACC-3000',
    code: '3',
    name: 'Patrimonio',
    type: 'EQUITY',
    level: 1,
    balance: 420000000
  },
  {
    id: 'ACC-4000',
    code: '4',
    name: 'Ingresos',
    type: 'REVENUE',
    level: 1,
    balance: 32500000
  },
  {
    id: 'ACC-5000',
    code: '5',
    name: 'Gastos',
    type: 'EXPENSE',
    level: 1,
    balance: 28750000
  }
];

export const journalEntries = [
  {
    id: 'JE-2024-00012',
    date: '2024-03-15',
    description: 'Registro de facturación PPA Parque Atacama',
    periodId: 'PER-2024-03',
    status: 'POSTED',
    sourceModule: 'FI-AR',
    currency: 'CLP',
    debit: 18500000,
    credit: 18500000,
    lines: [
      {
        accountCode: '1.1.2',
        accountName: 'Cuentas por Cobrar',
        debit: 18500000,
        credit: 0,
        costCenter: 'CC-ENERGIA',
        project: 'PRJ-PPA-01'
      },
      {
        accountCode: '4.1.1',
        accountName: 'Ingresos PPA',
        debit: 0,
        credit: 15546218,
        costCenter: 'CC-ENERGIA',
        project: 'PRJ-PPA-01'
      },
      {
        accountCode: '2.1.3',
        accountName: 'IVA Débito',
        debit: 0,
        credit: 2953782
      }
    ]
  },
  {
    id: 'JE-2024-00015',
    date: '2024-03-20',
    description: 'Registro factura proveedor mantenimiento turbinas',
    periodId: 'PER-2024-03',
    status: 'POSTED',
    sourceModule: 'FI-AP',
    currency: 'CLP',
    debit: 12850000,
    credit: 12850000,
    lines: [
      {
        accountCode: '5.2.4',
        accountName: 'Servicios de Mantenimiento',
        debit: 10800000,
        credit: 0,
        costCenter: 'CC-EOLICO',
        project: 'PRJ-TURB-EOL'
      },
      {
        accountCode: '1.1.5',
        accountName: 'IVA Crédito',
        debit: 2050000,
        credit: 0
      },
      {
        accountCode: '2.2.1',
        accountName: 'Proveedores Locales',
        debit: 0,
        credit: 12850000
      }
    ]
  }
];

export const accountsPayable = {
  vendors: [
    { id: 'VEND-001', name: 'SolarTech Ltd.', taxId: '76.123.456-7', status: 'Activo', paymentTerms: 30, balance: 21600000, lastInvoice: '2024-03-18' },
    { id: 'VEND-002', name: 'Montajes Industriales Sur', taxId: '77.987.654-3', status: 'Activo', paymentTerms: 15, balance: 11800000, lastInvoice: '2024-03-22' },
    { id: 'VEND-003', name: 'Servicios Andinos', taxId: '79.210.876-3', status: 'Activo', paymentTerms: 30, balance: 4650000, lastInvoice: '2024-03-25' },
    { id: 'VEND-004', name: 'ElectroMec Ltda.', taxId: '96.456.120-2', status: 'Activo', paymentTerms: 30, balance: 4520000, lastInvoice: '2024-03-24' },
    { id: 'VEND-005', name: 'TransLogística SPA', taxId: '80.654.987-5', status: 'Activo', paymentTerms: 15, balance: 7450000, lastInvoice: '2024-03-18' },
    { id: 'VEND-006', name: 'EnerGroup Chile', taxId: '65.789.123-1', status: 'Activo', paymentTerms: 30, balance: 42500000, lastInvoice: '2024-03-26' },
    { id: 'VEND-007', name: 'TechParts S.A.', taxId: '78.321.654-9', status: 'Activo', paymentTerms: 20, balance: 4070000, lastInvoice: '2024-03-18' },
    { id: 'VEND-008', name: 'MetalWorks Ltda.', taxId: '74.569.874-0', status: 'Suspendido', paymentTerms: 30, balance: 0, lastInvoice: '2024-03-16' },
    { id: 'VEND-009', name: 'PowerGrid Components', taxId: '98.741.236-5', status: 'Activo', paymentTerms: 45, balance: 33880000, lastInvoice: '2024-03-20' },
    { id: 'VEND-010', name: 'GreenField Supplies', taxId: '73.985.210-2', status: 'Activo', paymentTerms: 20, balance: 1180000, lastInvoice: '2024-03-20' },
    { id: 'VEND-011', name: 'Comercial Andina', taxId: '70.159.486-4', status: 'Activo', paymentTerms: 25, balance: 1680000, lastInvoice: '2024-03-20' },
    { id: 'VEND-012', name: 'GlobalParts LLC', taxId: '89.456.123-0', status: 'Activo', paymentTerms: 30, balance: 21560000, lastInvoice: '2024-03-22' },
    { id: 'VEND-013', name: 'LogiStore Chile', taxId: '71.320.548-9', status: 'Activo', paymentTerms: 15, balance: 740000, lastInvoice: '2024-03-22' }
  ],
  invoices: [
    {
      id: 'AP-INV-2101',
      vendor: 'SolarTech Ltd.',
      documentNumber: 'F-89001',
      issueDate: '2024-03-06',
      dueDate: '2024-03-20',
      currency: 'CLP',
      totalAmount: 14200000,
      status: 'PAID',
      project: 'PRJ-LEYDA-01',
      poNumber: 'OC-2101',
      poAmount: 14200000,
      goodsReceipt: 'GR-2101',
      postedAt: '2024-03-07T10:00:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-03-15T11:30:00',
      paymentStatus: 'PAID',
      paidAt: '2024-03-18T13:20:00',
      paidBy: 'usr-14',
      statusHistory: [
        {
          id: 'HIST-INV-2101-1',
          status: 'PENDING_POSTING',
          note: 'Factura cargada por finanzas.',
          userId: 'usr-16',
          timestamp: '2024-03-06T09:10:00'
        },
        {
          id: 'HIST-INV-2101-2',
          status: 'POSTED',
          note: 'Posteo FI contra OC-2101 y GR-2101.',
          userId: 'usr-13',
          timestamp: '2024-03-07T10:00:00'
        },
        {
          id: 'HIST-INV-2101-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Incluida en corrida de pagos Banco BCI.',
          userId: 'usr-14',
          timestamp: '2024-03-15T11:30:00'
        },
        {
          id: 'HIST-INV-2101-4',
          status: 'PAID',
          note: 'Pago ejecutado y conciliado.',
          userId: 'usr-14',
          timestamp: '2024-03-18T13:20:00'
        }
      ]
    },
    {
      id: 'AP-INV-2102',
      vendor: 'Montajes Industriales Sur',
      documentNumber: 'MIS-2145',
      issueDate: '2024-03-18',
      dueDate: '2024-04-17',
      currency: 'CLP',
      totalAmount: 8600000,
      status: 'PENDING_POSTING',
      project: 'PRJ-HURTADO-02',
      poNumber: 'OC-2102',
      poAmount: 8600000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2102-1',
          status: 'PENDING_POSTING',
          note: 'Factura en validación contra orden.',
          userId: 'usr-16',
          timestamp: '2024-03-18T16:05:00'
        }
      ]
    },
    {
      id: 'AP-INV-2103',
      vendor: 'Servicios Andinos',
      documentNumber: 'SA-3310',
      issueDate: '2024-03-20',
      dueDate: '2024-04-19',
      currency: 'CLP',
      totalAmount: 2750000,
      status: 'PENDING_POSTING',
      project: 'PRJ-LEYDA-MNT',
      poNumber: 'OC-2103',
      poAmount: 2750000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2103-1',
          status: 'PENDING_POSTING',
          note: 'Esperando validación de recepción.',
          userId: 'usr-16',
          timestamp: '2024-03-20T09:40:00'
        }
      ]
    },
    {
      id: 'AP-INV-2104',
      vendor: 'ElectroMec Ltda.',
      documentNumber: 'EM-5532',
      issueDate: '2024-03-21',
      dueDate: '2024-04-20',
      currency: 'CLP',
      totalAmount: 1840000,
      status: 'PENDING_POSTING',
      project: 'PRJ-HURTADO-CONST',
      poNumber: 'OC-2104',
      poAmount: 1840000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2104-1',
          status: 'PENDING_POSTING',
          note: 'Documento ingresado sin GR de respaldo.',
          userId: 'usr-16',
          timestamp: '2024-03-22T08:25:00'
        }
      ]
    },
    {
      id: 'AP-INV-2105',
      vendor: 'Montajes Industriales Sur',
      documentNumber: 'MIS-2152',
      issueDate: '2024-03-22',
      dueDate: '2024-04-16',
      currency: 'CLP',
      totalAmount: 3200000,
      status: 'PENDING_POSTING',
      project: 'PRJ-HURTADO-MNT',
      poNumber: 'OC-2105',
      poAmount: 3200000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2105-1',
          status: 'PENDING_POSTING',
          note: 'Se espera aprobación de Gerencia de Área.',
          userId: 'usr-16',
          timestamp: '2024-03-22T12:40:00'
        }
      ]
    },
    {
      id: 'AP-INV-2106',
      vendor: 'TransLogística SPA',
      documentNumber: 'TL-23045',
      issueDate: '2024-03-18',
      dueDate: '2024-04-15',
      currency: 'CLP',
      totalAmount: 4200000,
      status: 'SCHEDULED_PAYMENT',
      project: 'PRJ-SAN-LOG',
      poNumber: 'OC-2106',
      poAmount: 4200000,
      goodsReceipt: 'GR-2106',
      postedAt: '2024-03-19T11:50:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-04-02T09:00:00',
      paymentStatus: 'SCHEDULED',
      statusHistory: [
        {
          id: 'HIST-INV-2106-1',
          status: 'PENDING_POSTING',
          note: 'Factura ingresada y validada contra OC.',
          userId: 'usr-16',
          timestamp: '2024-03-18T18:15:00'
        },
        {
          id: 'HIST-INV-2106-2',
          status: 'POSTED',
          note: 'Posteada en FI con GR-2106.',
          userId: 'usr-13',
          timestamp: '2024-03-19T11:50:00'
        },
        {
          id: 'HIST-INV-2106-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Programada en corrida Santander.',
          userId: 'usr-14',
          timestamp: '2024-04-02T09:00:00'
        }
      ]
    },
    {
      id: 'AP-INV-2107',
      vendor: 'EnerGroup Chile',
      documentNumber: 'EG-9004',
      issueDate: '2024-03-19',
      dueDate: '2024-04-18',
      currency: 'USD',
      totalAmount: 28000,
      status: 'POSTED',
      project: 'PRJ-FRUTILLAS-BESS',
      poNumber: 'OC-2107',
      poAmount: 28000,
      goodsReceipt: null,
      postedAt: '2024-03-21T14:00:00',
      postedBy: 'usr-13',
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2107-1',
          status: 'PENDING_POSTING',
          note: 'Factura internacional recibida.',
          userId: 'usr-16',
          timestamp: '2024-03-19T15:30:00'
        },
        {
          id: 'HIST-INV-2107-2',
          status: 'POSTED',
          note: 'Posteada con verificación de tipo de cambio.',
          userId: 'usr-13',
          timestamp: '2024-03-21T14:00:00'
        }
      ]
    },
    {
      id: 'AP-INV-2108',
      vendor: 'TechParts S.A.',
      documentNumber: 'TP-5566',
      issueDate: '2024-03-17',
      dueDate: '2024-04-16',
      currency: 'CLP',
      totalAmount: 2150000,
      status: 'SCHEDULED_PAYMENT',
      project: 'PRJ-LEYDA-DEV',
      poNumber: 'OC-2108',
      poAmount: 2150000,
      goodsReceipt: 'GR-2108',
      postedAt: '2024-03-18T09:10:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-04-05T10:00:00',
      paymentStatus: 'SCHEDULED',
      statusHistory: [
        {
          id: 'HIST-INV-2108-1',
          status: 'PENDING_POSTING',
          note: 'Factura ingresada para validación.',
          userId: 'usr-16',
          timestamp: '2024-03-17T17:20:00'
        },
        {
          id: 'HIST-INV-2108-2',
          status: 'POSTED',
          note: 'Conciliada con recepción GR-2108.',
          userId: 'usr-13',
          timestamp: '2024-03-18T09:10:00'
        },
        {
          id: 'HIST-INV-2108-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Agendada en lote de pagos.',
          userId: 'usr-14',
          timestamp: '2024-04-05T10:00:00'
        }
      ]
    },
    {
      id: 'AP-INV-2109',
      vendor: 'MetalWorks Ltda.',
      documentNumber: 'MW-7712',
      issueDate: '2024-03-15',
      dueDate: '2024-04-14',
      currency: 'CLP',
      totalAmount: 5100000,
      status: 'REJECTED',
      project: 'PRJ-HURTADO-03',
      poNumber: 'OC-2109',
      poAmount: 5100000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2109-1',
          status: 'PENDING_POSTING',
          note: 'Factura recibida con observación de presupuesto.',
          userId: 'usr-16',
          timestamp: '2024-03-15T12:00:00'
        },
        {
          id: 'HIST-INV-2109-2',
          status: 'REJECTED',
          note: 'Rechazada por exceder tope mensual.',
          userId: 'usr-13',
          timestamp: '2024-03-16T09:10:00'
        }
      ]
    },
    {
      id: 'AP-INV-2110',
      vendor: 'PowerGrid Components',
      documentNumber: 'PG-4402',
      issueDate: '2024-03-18',
      dueDate: '2024-04-17',
      currency: 'USD',
      totalAmount: 38500,
      status: 'POSTED',
      project: 'PRJ-BESS-LEYDA',
      poNumber: 'OC-2110',
      poAmount: 38500,
      goodsReceipt: null,
      postedAt: '2024-03-20T08:45:00',
      postedBy: 'usr-13',
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2110-1',
          status: 'PENDING_POSTING',
          note: 'Factura internacional registrada.',
          userId: 'usr-16',
          timestamp: '2024-03-18T15:00:00'
        },
        {
          id: 'HIST-INV-2110-2',
          status: 'POSTED',
          note: 'Posteada en FI con retención de IVA.',
          userId: 'usr-13',
          timestamp: '2024-03-20T08:45:00'
        }
      ]
    },
    {
      id: 'AP-INV-2111',
      vendor: 'GreenField Supplies',
      documentNumber: 'GF-7801',
      issueDate: '2024-03-20',
      dueDate: '2024-04-19',
      currency: 'CLP',
      totalAmount: 1180000,
      status: 'PENDING_POSTING',
      project: 'PRJ-SR-MNT',
      poNumber: 'OC-2111',
      poAmount: 1180000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2111-1',
          status: 'PENDING_POSTING',
          note: 'Esperando aprobación Gerencia de Compras.',
          userId: 'usr-16',
          timestamp: '2024-03-20T13:55:00'
        }
      ]
    },
    {
      id: 'AP-INV-2112',
      vendor: 'Comercial Andina',
      documentNumber: 'CA-1245',
      issueDate: '2024-03-20',
      dueDate: '2024-04-19',
      currency: 'CLP',
      totalAmount: 1680000,
      status: 'SCHEDULED_PAYMENT',
      project: 'PRJ-HURTADO-OP',
      poNumber: 'OC-2112',
      poAmount: 1680000,
      goodsReceipt: 'GR-2112',
      postedAt: '2024-03-20T09:05:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-04-06T08:30:00',
      paymentStatus: 'SCHEDULED',
      statusHistory: [
        {
          id: 'HIST-INV-2112-1',
          status: 'PENDING_POSTING',
          note: 'Factura incorporada a FI.',
          userId: 'usr-16',
          timestamp: '2024-03-20T08:40:00'
        },
        {
          id: 'HIST-INV-2112-2',
          status: 'POSTED',
          note: 'Posteada con GR-2112.',
          userId: 'usr-13',
          timestamp: '2024-03-20T09:05:00'
        },
        {
          id: 'HIST-INV-2112-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Agendada en corrida BCI.',
          userId: 'usr-14',
          timestamp: '2024-04-06T08:30:00'
        }
      ]
    },
    {
      id: 'AP-INV-2113',
      vendor: 'GlobalParts LLC',
      documentNumber: 'GP-8841',
      issueDate: '2024-03-22',
      dueDate: '2024-04-21',
      currency: 'USD',
      totalAmount: 24500,
      status: 'PENDING_POSTING',
      project: 'PRJ-LEYDA-DEV',
      poNumber: 'OC-2113',
      poAmount: 24500,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2113-1',
          status: 'PENDING_POSTING',
          note: 'Factura internacional en revisión.',
          userId: 'usr-16',
          timestamp: '2024-03-22T14:50:00'
        }
      ]
    },
    {
      id: 'AP-INV-2114',
      vendor: 'Servicios Andinos',
      documentNumber: 'SA-3330',
      issueDate: '2024-03-25',
      dueDate: '2024-04-24',
      currency: 'CLP',
      totalAmount: 1900000,
      status: 'PENDING_POSTING',
      project: 'PRJ-HURTADO-DEV',
      poNumber: 'OC-2114',
      poAmount: 1900000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2114-1',
          status: 'PENDING_POSTING',
          note: 'Pendiente revisión del Project Manager.',
          userId: 'usr-16',
          timestamp: '2024-03-25T09:00:00'
        }
      ]
    },
    {
      id: 'AP-INV-2115',
      vendor: 'TransLogística SPA',
      documentNumber: 'TL-22890',
      issueDate: '2024-03-10',
      dueDate: '2024-03-30',
      currency: 'CLP',
      totalAmount: 3250000,
      status: 'PAID',
      project: 'PRJ-FRUTILLAS-LOG',
      poNumber: 'OC-2115',
      poAmount: 3250000,
      goodsReceipt: 'GR-2115',
      postedAt: '2024-03-10T10:20:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-03-12T08:00:00',
      paymentStatus: 'PAID',
      paidAt: '2024-03-13T09:40:00',
      paidBy: 'usr-14',
      statusHistory: [
        {
          id: 'HIST-INV-2115-1',
          status: 'PENDING_POSTING',
          note: 'Factura registrada por logística.',
          userId: 'usr-16',
          timestamp: '2024-03-10T09:50:00'
        },
        {
          id: 'HIST-INV-2115-2',
          status: 'POSTED',
          note: 'Posteada en FI.',
          userId: 'usr-13',
          timestamp: '2024-03-10T10:20:00'
        },
        {
          id: 'HIST-INV-2115-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Incluida en corrida de pagos.',
          userId: 'usr-14',
          timestamp: '2024-03-12T08:00:00'
        },
        {
          id: 'HIST-INV-2115-4',
          status: 'PAID',
          note: 'Pago conciliado Banco Santander.',
          userId: 'usr-14',
          timestamp: '2024-03-13T09:40:00'
        }
      ]
    },
    {
      id: 'AP-INV-2116',
      vendor: 'EnerGroup Chile',
      documentNumber: 'EG-9020',
      issueDate: '2024-03-23',
      dueDate: '2024-04-22',
      currency: 'USD',
      totalAmount: 19800,
      status: 'POSTED',
      project: 'PRJ-LEYDA-FW',
      poNumber: 'OC-2116',
      poAmount: 19800,
      goodsReceipt: null,
      postedAt: '2024-03-26T15:20:00',
      postedBy: 'usr-13',
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2116-1',
          status: 'PENDING_POSTING',
          note: 'Factura ingresada para posteo.',
          userId: 'usr-16',
          timestamp: '2024-03-23T13:35:00'
        },
        {
          id: 'HIST-INV-2116-2',
          status: 'POSTED',
          note: 'Posteo con conversión USD.',
          userId: 'usr-13',
          timestamp: '2024-03-26T15:20:00'
        }
      ]
    },
    {
      id: 'AP-INV-2117',
      vendor: 'ElectroMec Ltda.',
      documentNumber: 'EM-5590',
      issueDate: '2024-03-24',
      dueDate: '2024-04-23',
      currency: 'CLP',
      totalAmount: 2680000,
      status: 'PENDING_POSTING',
      project: 'PRJ-HURTADO-CC',
      poNumber: 'OC-2117',
      poAmount: 2680000,
      goodsReceipt: null,
      postedAt: null,
      postedBy: null,
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2117-1',
          status: 'PENDING_POSTING',
          note: 'Esperando firma de mantenimiento.',
          userId: 'usr-16',
          timestamp: '2024-03-24T16:25:00'
        }
      ]
    },
    {
      id: 'AP-INV-2118',
      vendor: 'TechParts S.A.',
      documentNumber: 'TP-5610',
      issueDate: '2024-03-18',
      dueDate: '2024-04-17',
      currency: 'CLP',
      totalAmount: 960000,
      status: 'PAID',
      project: 'PRJ-LEYDA-OP',
      poNumber: 'OC-2118',
      poAmount: 960000,
      goodsReceipt: 'GR-2118',
      postedAt: '2024-03-18T09:30:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-03-20T08:30:00',
      paymentStatus: 'PAID',
      paidAt: '2024-03-21T12:10:00',
      paidBy: 'usr-14',
      statusHistory: [
        {
          id: 'HIST-INV-2118-1',
          status: 'PENDING_POSTING',
          note: 'Factura recibida y registrada.',
          userId: 'usr-16',
          timestamp: '2024-03-18T08:50:00'
        },
        {
          id: 'HIST-INV-2118-2',
          status: 'POSTED',
          note: 'Posteada con GR-2118.',
          userId: 'usr-13',
          timestamp: '2024-03-18T09:30:00'
        },
        {
          id: 'HIST-INV-2118-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Incluida en pago express BCI.',
          userId: 'usr-14',
          timestamp: '2024-03-20T08:30:00'
        },
        {
          id: 'HIST-INV-2118-4',
          status: 'PAID',
          note: 'Pago confirmado.',
          userId: 'usr-14',
          timestamp: '2024-03-21T12:10:00'
        }
      ]
    },
    {
      id: 'AP-INV-2119',
      vendor: 'SolarTech Ltd.',
      documentNumber: 'F-90112',
      issueDate: '2024-03-23',
      dueDate: '2024-04-22',
      currency: 'CLP',
      totalAmount: 7200000,
      status: 'POSTED',
      project: 'PRJ-LEYDA-TRAMO-C',
      poNumber: 'OC-2119',
      poAmount: 7200000,
      goodsReceipt: null,
      postedAt: '2024-03-25T10:45:00',
      postedBy: 'usr-13',
      paymentScheduledAt: null,
      paymentStatus: 'UNPLANNED',
      statusHistory: [
        {
          id: 'HIST-INV-2119-1',
          status: 'PENDING_POSTING',
          note: 'Factura ingresada para verificación.',
          userId: 'usr-16',
          timestamp: '2024-03-23T12:15:00'
        },
        {
          id: 'HIST-INV-2119-2',
          status: 'POSTED',
          note: 'Posteada con control de precio vs OC.',
          userId: 'usr-13',
          timestamp: '2024-03-25T10:45:00'
        }
      ]
    },
    {
      id: 'AP-INV-2120',
      vendor: 'LogiStore Chile',
      documentNumber: 'LS-45079',
      issueDate: '2024-03-22',
      dueDate: '2024-04-21',
      currency: 'CLP',
      totalAmount: 740000,
      status: 'SCHEDULED_PAYMENT',
      project: 'PRJ-SR-BODEGA',
      poNumber: 'OC-2120',
      poAmount: 740000,
      goodsReceipt: 'GR-2120',
      postedAt: '2024-03-22T09:40:00',
      postedBy: 'usr-13',
      paymentScheduledAt: '2024-04-08T09:15:00',
      paymentStatus: 'SCHEDULED',
      statusHistory: [
        {
          id: 'HIST-INV-2120-1',
          status: 'PENDING_POSTING',
          note: 'Factura registrada con GR-2120.',
          userId: 'usr-16',
          timestamp: '2024-03-22T09:10:00'
        },
        {
          id: 'HIST-INV-2120-2',
          status: 'POSTED',
          note: 'Posteada para pago futuro.',
          userId: 'usr-13',
          timestamp: '2024-03-22T09:40:00'
        },
        {
          id: 'HIST-INV-2120-3',
          status: 'SCHEDULED_PAYMENT',
          note: 'Pago programado en ciclo de abril.',
          userId: 'usr-14',
          timestamp: '2024-04-08T09:15:00'
        }
      ]
    }
  ],
  aging: [
    { bucket: 'Al día', amount: 68500000 },
    { bucket: '1-30 días', amount: 52400000 },
    { bucket: '31-60 días', amount: 18000000 },
    { bucket: '61-90 días', amount: 1824000 },
    { bucket: '90+ días', amount: 0 }
  ]
};

export const accountsReceivable = {
  customers: [
    {
      id: 'CUST-001',
      name: 'Distribuidora Eléctrica Norte',
      taxId: '96.542.130-5',
      status: 'Activo',
      paymentTerms: 30,
      balance: 21500000,
      lastInvoice: '2024-03-15'
    },
    {
      id: 'CUST-002',
      name: 'Consorcio Energía Limpia',
      taxId: '88.345.678-2',
      status: 'Activo',
      paymentTerms: 45,
      balance: 23500000,
      lastInvoice: '2024-03-28'
    }
  ],
  invoices: [
    {
      id: 'AR-INV-001',
      customer: 'Distribuidora Eléctrica Norte',
      documentNumber: 'F-90012',
      issueDate: '2024-03-15',
      dueDate: '2024-04-14',
      currency: 'CLP',
      totalAmount: 18500000,
      status: 'POSTED',
      project: 'PRJ-PPA-01'
    },
    {
      id: 'AR-INV-002',
      customer: 'Consorcio Energía Limpia',
      documentNumber: 'F-90013',
      issueDate: '2024-03-28',
      dueDate: '2024-04-27',
      currency: 'CLP',
      totalAmount: 16500000,
      status: 'POSTED',
      project: 'PRJ-OM-02'
    }
  ],
  aging: [
    { bucket: 'Al día', amount: 31800000 },
    { bucket: '1-30 días', amount: 9200000 },
    { bucket: '31-60 días', amount: 4000000 },
    { bucket: '61-90 días', amount: 0 },
    { bucket: '90+ días', amount: 0 }
  ]
};

export const fixedAssets = [
  {
    id: 'FA-001',
    code: 'AF-PLANTA-001',
    name: 'Planta Solar Cerro Dominador',
    acquisitionDate: '2021-04-20',
    acquisitionValue: 325000000,
    accumulatedDepreciation: 72000000,
    currentValue: 253000000,
    depreciationMethod: 'LINEAL',
    usefulLife: 180,
    costCenter: 'CC-SOLAR',
    project: 'PRJ-PLANTA-01'
  },
  {
    id: 'FA-004',
    code: 'AF-EOLICO-003',
    name: 'Turbinas Eólicas Vestas V136',
    acquisitionDate: '2022-11-01',
    acquisitionValue: 215000000,
    accumulatedDepreciation: 24000000,
    currentValue: 191000000,
    depreciationMethod: 'ACELERADA',
    usefulLife: 120,
    costCenter: 'CC-EOLICO',
    project: 'PRJ-TURB-EOL'
  }
];

export const bankAccounts = [
  {
    id: 'BANK-001',
    bankName: 'BancoEstado',
    accountNumber: '12345678',
    currency: 'CLP',
    balance: 98000000,
    lastReconciliation: '2024-03-20'
  },
  {
    id: 'BANK-002',
    bankName: 'Santander',
    accountNumber: '87654321',
    currency: 'USD',
    balance: 750000,
    lastReconciliation: '2024-03-18'
  }
];

export const cashFlowSeries = {
  labels: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4'],
  inflows: [9500000, 11200000, 13250000, 9800000],
  outflows: [8200000, 9650000, 11800000, 8900000]
};

export const taxCodes = [
  {
    id: 'TX-IVA19',
    code: 'IVA19',
    description: 'IVA 19% Débito',
    rate: 0.19,
    type: 'VAT',
    debitAccount: '1.1.5',
    creditAccount: '2.1.3'
  },
  {
    id: 'TX-RET24',
    code: 'RET24',
    description: 'Retención Honorarios 24%',
    rate: 0.24,
    type: 'WITHHOLDING',
    debitAccount: '5.9.1',
    creditAccount: '2.4.3'
  }
];

export const comparativeReports = {
  balanceSheet: [
    { label: 'Activos Totales', current: 945000000, previous: 902000000 },
    { label: 'Pasivos Totales', current: 410000000, previous: 395000000 },
    { label: 'Patrimonio', current: 535000000, previous: 507000000 }
  ],
  incomeStatement: [
    { label: 'Ingresos', current: 32500000, previous: 30500000 },
    { label: 'Costos', current: 18500000, previous: 18200000 },
    { label: 'Gastos', current: 10250000, previous: 9650000 },
    { label: 'Resultado Operacional', current: 3750000, previous: 2650000 }
  ],
  cashFlow: [
    { label: 'Operación', current: 4200000, previous: 3120000 },
    { label: 'Inversión', current: -1250000, previous: -1450000 },
    { label: 'Financiamiento', current: 890000, previous: 1200000 }
  ]
};

export const integrationHooks = [
  {
    module: 'MM - Compras',
    description: 'Generación automática de facturas de proveedores y asientos de recepción de mercancías.',
    endpoints: ['/api/mm/purchase-orders/:id/fi/sync', '/api/fi/ap/invoices'],
    status: 'Activo'
  },
  {
    module: 'SD - Ventas',
    description: 'Emisión de facturas a clientes y registro de ingresos por PPA.',
    endpoints: ['/api/sd/invoices', '/api/fi/ar/invoices'],
    status: 'Activo'
  },
  {
    module: 'PS - Proyectos',
    description: 'Capitalización de activos y asignación de centros de costo.',
    endpoints: ['/api/ps/projects/:id/assets', '/api/fi/assets'],
    status: 'En pruebas'
  },
  {
    module: 'RRHH',
    description: 'Provisionamiento automático de remuneraciones y anticipos.',
    endpoints: ['/api/hr/payroll/provisions', '/api/fi/gl/journals'],
    status: 'Planificado'
  }
];
